import DetailsTitle from './DetailsTitle';

export default DetailsTitle;
